import CountryDataService from "@/services/CountryDataService";
import ContainerDataService from "@/services/ContainerDataService";
import SchemeDataService from "@/services/SchemeDataService";
import UserDataService from "@/services/UserDataService";
import CustomerDataService from "@/services/CustomerProfileDataService";
// @group Mixins
export default {
  data() {
    return {
      schemes: [],
      containers: [],
      countries: [],
      users: [],
      customers: [],
      countryMap: {},
      containerMap: {},
      schemeMap: {},
      countryCodeMap: {},
      userMap: {},
      containerDataService: new ContainerDataService(),
      countryDataService: new CountryDataService(),
      schemeDataService: new SchemeDataService(),
      userDataService: new UserDataService(),
      CustomerDataService: new CustomerDataService()
    };
  },
  computed: {
    countryList() {
      return this.$store.state.countryList;
    },
    schemeList() {
      return this.$store.state.schemeList;
    },
    containerList() {
      return this.$store.state.containerList;
    },
    userList() {
      return this.$store.state.userList;
    },
    customerList() {
      return this.$store.state.customerList;
    }
  },
  methods: {
    find_column_index(column_name) {
      if (this.columns) {
        return this.columns.findIndex(col => col.field === column_name);
      }
      return null;
    },

    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    prepareCountryCodeData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["code"];
      }
      return resultDict;
    },
    fetchCountries(callback) {
      if (this.$store.state.countryList.length > 0) {
        this.countries = this.$store.state.countryList;
        this.countryNames = this.countries.map(obj => obj.name);
        this.countryMap = this.prepareMasterData(this.countries);
        this.countryCodeMap = this.prepareCountryCodeData(this.countries);
        let countryIndex = this.find_column_index("country");
        if (countryIndex == -1)
          countryIndex = this.find_column_index("country_name");
        if (countryIndex && countryIndex > -1) {
          this.columns[countryIndex]["allStatusVals"] = this.countries;
        }
        // Execute callback if provided
        if (callback && typeof callback === "function") {
          callback();
        }
      } else {
        const countriesObservable = this.countryDataService.getAll();
        countriesObservable.subscribe(
          response => {
            this.countries = response;
            this.$store.dispatch("setCountryList", response);
            this.countryNames = this.countries.map(obj => obj.name);
            this.countryMap = this.prepareMasterData(this.countries);
            this.countryCodeMap = this.prepareCountryCodeData(this.countries);
            let countryIndex = this.find_column_index("country");
            if (countryIndex == -1)
              countryIndex = this.find_column_index("country_name");
            if (countryIndex && countryIndex > -1) {
              this.columns[countryIndex]["allStatusVals"] = response;
            }
            // Execute callback if provided
            if (callback && typeof callback === "function") {
              callback();
            }
          },
          e => {
            console.log(e);
          }
        );
      }
      //return countriesObservable; // return for forkJoin
    },

    fetchContainers() {
      if (this.$store.state.containerList.length > 0) {
        this.containers = this.containerList;
        this.containerMap = this.prepareMasterData(this.containers);
        let streamIndex = this.find_column_index("stream");
        if (streamIndex == -1)
          streamIndex = this.find_column_index("stream_name");
        if (streamIndex && streamIndex > -1) {
          this.columns[streamIndex].allStatusVals = this.containers;
        }
        this.containerMap = this.prepareMasterData(this.containers);
      } else {
        const containersObservable = this.containerDataService.getAll();
        containersObservable.subscribe(
          response => {
            this.containers = response;
            this.$store.dispatch("setContainerList", response);
            let streamIndex = this.find_column_index("stream");
            if (streamIndex == -1)
              streamIndex = this.find_column_index("stream_name");
            if (streamIndex && streamIndex > -1) {
              this.columns[streamIndex].allStatusVals = response;
            }

            this.containerMap = this.prepareMasterData(this.containers);
          },
          e => {
            console.log(e);
          }
        );
      }
      //return containersObservable; // return for forkJoin
    },

    fetchSchemes(isFormView = false) {
      if (this.$store.state.schemeList.length > 0) {
        this.schemes = this.schemeList;
        let schemesIndex = this.find_column_index("scheme");
        if (schemesIndex == -1)
          schemesIndex = this.find_column_index("scheme_name");
        if (schemesIndex && schemesIndex > -1) {
          this.columns[schemesIndex].allStatusVals = this.schemes;
        }
        if (!isFormView) this.schemeMap = this.prepareMasterData(this.schemes);
      } else {
        const schemesObservable = this.schemeDataService.getAll();
        schemesObservable.subscribe(
          response => {
            this.schemes = response;
            let schemesIndex = this.find_column_index("scheme");
            if (schemesIndex == -1)
              schemesIndex = this.find_column_index("scheme_name");
            if (schemesIndex && schemesIndex > -1) {
              this.columns[schemesIndex].allStatusVals = this.schemes;
            }
            this.$store.dispatch("setSchemeList", response);
            if (!isFormView)
              this.schemeMap = this.prepareMasterData(this.schemes);
          },
          e => {
            console.log(e);
          }
        );
      }
      //return schemesObservable; // return for forkJoin
    },
    fetchCustomerProfileData(customerId, switchCustomerEnabled = false) {
      if (this.customerList.length > 0 && switchCustomerEnabled == false) {
        this.customers = this.customerList;
      } else {
        const customerObservable = this.CustomerDataService.getCustomerList(
          customerId
        );
        customerObservable.subscribe(
          response => {
            this.customers = response;
            this.customers = this.customers.filter(function(obj) {
              return obj.active == true;
            });
            this.customers.sort(function(a, b) {
              if (a.name.toUpperCase() < b.name.toUpperCase()) {
                return -1;
              }
              if (a.name.toUpperCase() > b.name.toUpperCase()) {
                return 1;
              }
              // names must be equal
              return 0;
            });
            this.$store.dispatch("setCustomerList", this.customers);
          },
          e => {
            if (
              e.response.status == 403 &&
              e.response.data.code == "token_not_valid"
            ) {
              alert("Session expired, please login again");
              this.authService.logout(this.$keycloak);
            }
          }
        );
      }
    },
    fetchUserData() {
      if (this.userList.length > 0) {
        this.users = this.userList;
        this.userMap = this.prepareMasterData(this.users);
        //this.setUserRoles();
      } else {
        const userObservable = this.userDataService.getAll();
        userObservable.subscribe(
          response => {
            this.users = response;
            for (const user of this.users) {
              if (user.is_active == false) {
                user.name = user.name + "(Inactive)";
                // this.users = this.users.filter(e => e.id !== user.id);
              }
            }
            this.$store.dispatch("setUserList", this.users);
            this.userMap = this.prepareMasterData(this.users);
            //this.setUserRoles();
          },
          e => {
            if (
              e.response.status == 403 &&
              e.response.data.code == "token_not_valid"
            ) {
              alert("Session expired, please login again");
              this.authService.logout(this.$keycloak);
            }
          }
        );
      }
    }
  }
};
